// extracted by mini-css-extract-plugin
export default {"label":"checkbox_label__DakzW"};